// src/sections/Images.jsx
import React from "react";

const Images = ({ contenuti }) => {
  // Trasforma l'oggetto in array di sezioni
  const sections = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  return (
    <section style={{margin:'74px 0'}}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {sections.map((section, idx) => {
              const { titolo_it, descrizione_it = "" } = section;
              const mode = titolo_it?.toLowerCase() === "full" ? "full" : "split";
              return (
                <div key={idx} className={`mb-4 ${mode}`}>
                  <h2 className="h4">{titolo_it}</h2>
                  <p
                      style={{ whiteSpace: "pre-line" }}
                      dangerouslySetInnerHTML={{ __html: descrizione_it }}
                    />

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Images;
